import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { LogIn, Menu, ShoppingBag, ShieldCheck, X } from "lucide-react";

const MemberLabel = () => (useAuth().isSignedIn ? "My Dashboard" : "Member Login");
import { useAuth } from "@clerk/react";
import { useCart } from "@/lib/cart";

export const NAV = [
  ["/", "Home", "home"],
  ["/packages", "Packages", "packages"],
  ["/products", "Products", "products"],
  ["/distributor/register", "Join", "register"],
  ["/careers", "Careers", "careers"],
  ["/my-orders", "My Orders", "my-orders"],
  ["/contact", "Support", "contact"],
];

const EXTRA = [["/about", "About Us", "about"], ["/my-applications", "My Applications", "my-applications"], ["/member/login", "Member Login", "member-login"], ["/admin", "Admin Login", "admin-login"]];

export const Logo = ({ light }) => (
  <Link to="/" className="flex items-center gap-2.5" data-testid="site-logo">
    <span className="grid h-10 w-10 place-items-center rounded-lg bg-amber-600 font-display text-sm font-extrabold text-white">BMI</span>
    <span className={`whitespace-nowrap font-display text-lg font-bold leading-none tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
      BMI SP <span className="text-amber-600">GROUP</span>
    </span>
  </Link>
);

const linkCls = ({ isActive }) =>
  `whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { count, setOpen: openCart } = useCart();
  return (
    <header className="no-print sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur-md">
      <div className="container-x flex h-16 items-center justify-between gap-4">
        <Logo />
        <nav className="hidden items-center gap-0.5 xl:flex">
          {NAV.map(([to, label, id]) => (
            <NavLink key={to} to={to} end={to === "/"} className={linkCls} data-testid={`nav-${id}`}>{label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button onClick={() => openCart(true)} className="relative grid h-10 w-10 place-items-center rounded-full border border-slate-200 transition-colors hover:bg-slate-100" data-testid="cart-button" aria-label="Open cart">
            <ShoppingBag className="h-4 w-4" />
            {count > 0 && <span className="absolute -right-1 -top-1 grid h-5 min-w-5 place-items-center rounded-full bg-amber-600 px-1 text-[10px] font-bold text-white" data-testid="cart-count">{count}</span>}
          </button>
          <Link to="/member" className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-amber-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-amber-700 md:flex" data-testid="nav-member-login">
            <LogIn className="h-4 w-4" /> <MemberLabel />
          </Link>
          <Link to="/admin" className="hidden items-center gap-1.5 rounded-full border border-slate-900 px-4 py-2 text-sm font-semibold text-slate-900 transition-colors hover:bg-slate-900 hover:text-white 2xl:flex" data-testid="nav-admin-login">
            <ShieldCheck className="h-4 w-4" /> Admin
          </Link>
          <button className="grid h-10 w-10 place-items-center rounded-full border border-slate-200 xl:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="container-x flex flex-col gap-1 border-t border-slate-100 py-3 xl:hidden" data-testid="mobile-menu">
          {[...NAV, ...EXTRA].map(([to, label, id]) => (
            <NavLink key={to} to={to} end={to === "/"} className={linkCls} onClick={() => setOpen(false)} data-testid={`mobile-nav-${id}`}>{label}</NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
